import { func, shape, object, bool } from 'prop-types';
import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { get, renderCheck } from 'ravenjs/utils';
import { AlertIcon, Typography } from 'ravenjs/lib';

import { MODALS } from 'constants/modals';
import { sanitizeMarkup } from 'utils/sanitize';
import { actions as uiActions, selectors as uiSelectors } from 'modules/ui';
import Modal from '../Modal';

const ModalContainerStyled = styled.div`
    position: relative;

    ${({ theme, padding }) => theme.media.up('md')`
        padding: ${padding};
        width: 100%;
    `};
    ${({ theme }) => theme.media.down('md')`
        padding: 2.1875rem 2rem 0 2rem;
    `};
    ${({ theme }) => theme.media.down('sm')`
        padding: 0;
    `};
`;

const ViewPreppedAnswersModalStyled = styled.div`
    align-items: center;
    display: flex;
    justify-content: flex-start;
    height: 100%;
    > * {
        width: 100%;
        height: 100%;
        margin-right: 10px;
        ${({ textAlign, theme }) => theme.media.down('md')`
            text-align: ${textAlign};
        `};
        ${({ theme }) => theme.media.up('md')`
            text-align: left;
        `};
        &:last-child {
            margin-right: 0;
        }
    }
    iframe {
        width: 100% !important;
        height: ${({ autoHeighIframe }) => (autoHeighIframe ? '100%' : '520px')};
        ${({ theme }) => theme.media.up('xxl')`
            height: ${({ autoHeighIframe }) => (autoHeighIframe ? '100%' : '550px')};
        `};
        ${({ theme }) => theme.media.down('md')`
            height: ${({ autoHeighIframe }) => (autoHeighIframe ? '100%' : 'auto')};
            min-height: 480px;
        `};
    }
    ${({ theme }) => theme.media.down('md')`
        flex-direction: column;
    `};
    ${({ theme }) => theme.media.up('md')`
        flex-direction: row;
    `};
`;

const DescriptionStyled = styled.div``;

class ViewPreppedAnswersModal extends Component {
    static propTypes = {
        closeModal: func.isRequired,
        modal: shape({
            data: object,
            open: bool,
        }),
        hideIcon: bool,
    };

    static defaultProps = {
        modal: {
            open: false,
            data: null,
        },
        hideIcon: false,
    };

    getModalProps = () => {
        const { modal } = this.props;
        const ModalProps = get(modal, 'data.ModalProps', {});
        const actions = get(modal, 'data.actions', []);
        const cancelBtnProps = get(modal, 'data.cancelBtnProps');
        const onCancel = get(modal, 'data.onCancel');
        const onSuccess = get(modal, 'data.onSuccess');
        const hasCloseIcon = get(modal, 'data.hasCloseIcon');
        const open = get(modal, 'open', false);
        const successBtnProps = get(modal, 'data.successBtnProps');
        const justifyActions = get(modal, 'data.justifyActions', 'center !important');
        const modalProps = get(modal, 'data.modalProps', {});
        const hideActions = get(modal, 'data.hideActions', false);
        const modalHeaderProps = get(modalProps, 'headerProps', {});
        const modalBodyProps = get(modalProps, 'bodyProps', false);
        const modalFooterProps = get(modalProps, 'footerProps', {});
        const autoHeighIframe = get(modal, 'data.autoHeighIframe', false);
        const title = get(modal, 'data.title', '');
        const modalBodyPropsDefault = {
            padding: '15px 15px 0',
            borderRadius: '4px 4px 0 0',
        };

        if (autoHeighIframe) {
            modalBodyPropsDefault.display = 'flex';
            modalBodyPropsDefault.overflow = 'hidden';
        }

        return {
            actions,
            cancelBtnProps,
            content: this.renderContent(),
            hideActions,
            id: MODALS.VIEW_PREPPED_ANSWERS_MODAL,
            justifyActions,
            onCancel,
            onClickCloseIcon: hasCloseIcon ? this.handleCloseModal : null,
            onSuccess,
            open,
            successBtnProps,
            ModalProps,
            modalHeaderProps,
            modalBodyProps: modalBodyProps || modalBodyPropsDefault,
            modalFooterProps,
            title,
        };
    };

    handleCloseModal = () => {
        const { closeModal, modal } = this.props;
        const onCloseIcon = get(modal, 'data.onCloseIcon', null);

        if (onCloseIcon) {
            onCloseIcon();
        } else {
            closeModal(MODALS.VIEW_PREPPED_ANSWERS_MODAL);
        }
    };

    renderContent = () => {
        const { modal } = this.props;
        const description = get(modal, 'data.description');
        const isComponent = get(modal, 'data.isComponent');
        const alertDescription = get(modal, 'data.alertDescription');
        const hideIcon = get(modal, 'data.hideIcon');
        const paddingContainer = get(modal, 'data.paddingContainer', '0');
        const autoHeighIframe = get(modal, 'data.autoHeighIframe', false);
        const textAlign = get(modal, 'data.textAlign', 'center');

        return (
            <>
                <ModalContainerStyled padding={paddingContainer}>
                    <ViewPreppedAnswersModalStyled
                        autoHeighIframe={autoHeighIframe}
                        textAlign={textAlign}
                    >
                        {!hideIcon ? (
                            <AlertIcon style={{ width: 45, height: 'auto', color: '#E62C14' }} />
                        ) : null}
                        <DescriptionStyled>
                            {!isComponent ? (
                                <Typography
                                    dangerouslySetInnerHTML={sanitizeMarkup(description)}
                                    gutterTop="0"
                                    gutterBottom="0"
                                    fontFamily="Roboto"
                                />
                            ) : (
                                description
                            )}
                        </DescriptionStyled>
                    </ViewPreppedAnswersModalStyled>
                    <ViewPreppedAnswersModalStyled>
                        <Typography
                            style={{
                                paddingTop: 3,
                                marginLeft: renderCheck('md', 'less') ? '0' : 54,
                                color: '#E62C14',
                            }}
                            dangerouslySetInnerHTML={sanitizeMarkup(alertDescription)}
                            gutterTop="0"
                            gutterBottom="0"
                        />
                    </ViewPreppedAnswersModalStyled>
                </ModalContainerStyled>
            </>
        );
    };

    render() {
        return <Modal {...this.getModalProps()} />;
    }
}

const mapStateToProps = createStructuredSelector({
    modal: uiSelectors.getModalById(MODALS.VIEW_PREPPED_ANSWERS_MODAL),
});

const mapDispatchToProps = {
    closeModal: uiActions.closeModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(ViewPreppedAnswersModal);
